import React, { useRef, useState } from 'react';
import { ColumnDef } from '@tanstack/table-core';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { getHeaderName } from 'src/components/collapsible-table/table-column-prep';
import { Grid } from '@mui/material';
import { handleGlobalNumericValueInputChange } from '../store/table-slice';
import { handleGlobalNumericValueInputChange as handleGlobalNumericValueInputChange2 } from '../store/table-slice2';
import AbsoluteInputBox from '../../../../pricing-simulator/components/table-columns/absolute-input-box';
import {
  Header,
  TableComponent,
  InputType,
} from '../../../../pricing-simulator/types/generic-table.model';
import { IMPLEMENTATION_PERIOD_2_KEY } from 'src/constants';

const HeaderComponent = ({ props, columnData, componentType, inputsDisabled, isDisplayHeader }) => {
  const appDispatch = useAppDispatch();
  const [value, setValue] = React.useState<number>();
  const valueRef = React.useRef<number>();
  const { pricingAction2Value } = useAppSelector((state) => state.table);
  const { kpi2ColumnMapping } = useAppSelector((state) => state.pricingSimulator);
  let isDisabled = false;
  if (!pricingAction2Value || pricingAction2Value === 0) {
    const columnId = props.column.id || '';
    if (kpi2ColumnMapping.includes(columnId)) isDisabled = true;
  }
  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(Number(e.target.value));
  };
  const handleBlur = () => {
    if (valueRef.current === value) return;
    valueRef.current = value;
    if (TableComponent.COGS === componentType) {
      appDispatch(
        handleGlobalNumericValueInputChange2({
          columnMetadata: columnData,
          newValue: value,
        })
      );
    } else {
      appDispatch(
        handleGlobalNumericValueInputChange({
          columnMetadata: columnData,
          newValue: value,
        })
      );
    }
  };
  return (
    <Grid container alignItems="center" flexDirection="column">
      <Grid
        item
        xs="auto"
        container
        alignItems="center"
        className="change-text"
        onClick={props.column.getToggleSortingHandler()}
      >
        {isDisplayHeader && (
          <Grid item sx={{ cursor: 'pointer' }}>
            {columnData?.parent?.alias}
          </Grid>
        )}
      </Grid>
      {columnData?.parent?.field_format === 'NUMBER' &&
        columnData?.parent?.is_global_input_enable && (
          <Grid item xs="auto" style={{ margin: 'auto' }}>
            <input
              value={Math.floor((value || 0) * 100) / 100}
              className="table-input-box"
              type="number"
              disabled={inputsDisabled || isDisabled}
              onChange={handleValueChange}
              onBlur={handleBlur}
            />
          </Grid>
        )}
    </Grid>
  );
};

const CellComponent = ({
  cell,
  row,
  columnData,
  columnMetadata,
  componentType,
  inputsDisabled,
  currentColumnData
}) => {
  const { summary: summaryAccessConfig } = useAppSelector(
    (state) => state.simulatorHome.moduleAccessMap
  );
  const { kpi2ColumnMapping } = useAppSelector(
    (state) => state.pricingSimulator
  );
  let disabled = false;
  const implementPeriod2Value =
    row.original?.[IMPLEMENTATION_PERIOD_2_KEY] || 0;
  if (implementPeriod2Value === 0) {
    const cellId = cell.column?.id || '';
    if (kpi2ColumnMapping.includes(cellId)) disabled = true;
  }
  const idColumns = columnMetadata
    .filter(
      (data) =>
        !data.parent.is_visible &&
        data.parent.field_format === InputType.NUMBER
    )
    .sort((a, b) => a.parent.level - b.parent.level);
  if (TableComponent.MULTIYEARESTIMATE === componentType) {
    const isParent = !row.getParentRow();
    if (isParent || row.index === 0) {
      return <span>-</span>;
    }
  }
  return (
    <AbsoluteInputBox
      row={row}
      columnMetadata={columnData}
      uniqueIDColumns={idColumns}
      componentType={componentType}
      comparisonColumnMetadata={currentColumnData}
      inputsDisabled={
        inputsDisabled ||
        (TableComponent.MULTIYEARESTIMATE === componentType &&
          !summaryAccessConfig?.provide_inputs_multi_year_estimate) ||
        disabled
      }
    />
  );
};

export default function GetColumnForNumericType(
  columnData: Header,
  columnMetadata: Header[],
  componentType: TableComponent,
  comparisonColumnMetadata?: Header,
  maxVal?: number,
  inputsDisabled?: boolean,
  isDisplayHeader?: boolean
) {
  let currentColumnData = { parent: { parent_field: '' }, chideren: [] };
  if (comparisonColumnMetadata && comparisonColumnMetadata.children.length) {
    currentColumnData = comparisonColumnMetadata.children.find(
      headerMetadata => headerMetadata.parent.alias === 'Current'
    );
  }

  const subHeader: ColumnDef<{ [key: string]: number | string }> = {
    accessorKey: columnData?.parent?.parent_field,
    meta: {
      className:
        columnData?.parent?.order === maxVal || maxVal === undefined
          ? 'last'
          : '',
      style: { minWidth: '125px', textAlign: 'center' },
    },
    header: (props) => (

      <HeaderComponent
        props={props}
        columnData={columnData}
        componentType={componentType}
        inputsDisabled={inputsDisabled}
        isDisplayHeader={isDisplayHeader}
      />

    ),
    cell: ({ cell, row }) => (
      <CellComponent
        cell={cell}
        row={row}
        columnData={columnData}
        columnMetadata={columnMetadata}
        componentType={componentType}
        inputsDisabled={inputsDisabled}
        currentColumnData={currentColumnData}
      />
    ),
  }
    return subHeader;
};
